import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BYME_MESSAGES } from "src/app/enum/byme-messages";
import { BymeService } from "src/app/services/byme.service";
import { GTM } from "src/app/services/gtm.service";
import { UserService } from "src/app/services/user.service";
import { MODAL, ModalService } from "../../services/modal.service";

@Component({
  selector: "ng-hbm-bdi-order-message",
  templateUrl: "./order-message.component.html",
})
export class OrderMessageComponent {
  public handledBom: any;
  orderProcessing: boolean;
  bom: any;
  flattenBom: any;

  constructor(
    public modalService: ModalService,
    public byMeService: BymeService,
    private gtm: GTM,
    private user: UserService,
    private translate: TranslateService
  ) {
    this.bom = modalService.currentDatas.bom;
    this.flattenBom = modalService.currentDatas.flattenBom;
  }

  continue() {
    this.gtm.trackEvent(
      "click",
      "products-list-" + this.user.context.toLowerCase(),
      "order",
      { project_amount: this.bom.totalPrice.toFixed(2) }
    );
    this.orderProcessing = true;
    this.byMeService.saveForOrderRequested = true;
    this.byMeService.postMessageToIFrame(BYME_MESSAGES.SAVE_REQUESTED, {});
  }

  contact() {
    window.open(this.translate.instant("popins.order_message.url"), "_blank");
  }

  close() {
    this.modalService.display(MODAL.PRODUCTS_LIST, {
      bom: this.bom,
      flattenBom: this.flattenBom,
    });
  }
}
